import { createBrowserRouter } from 'react-router-dom';

import { ensureGtag } from 'utils/analytics';

// routes
import AuthenticationRoutes from './routes/AuthenticationRoutes';
import LoginRoutes from './routes/LoginRoutes';
import PublicRoutes from './routes/MainRoutes';
import AuthenticatedRoutes from './routes/AuthenticatedRoutes';
import ShipmentRoutes from './routes/ShipmentRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([PublicRoutes, AuthenticatedRoutes, AuthenticationRoutes, LoginRoutes, ShipmentRoutes], {
  basename: import.meta.env.VITE_APP_BASE_NAME
});

// ==============================|| GOOGLE ANALYTICS SPA TRACKING ||============================== //

const measurementId = import.meta.env.VITE_APP_GA_MEASUREMENT_ID;
if (measurementId) {
  // Ensure gtag is globally available before the component mounts
  ensureGtag();
  const gtag = window.gtag!;

  let currentPath = router.state.location.pathname;

  // Track initial page load (without query params to avoid PII)
  gtag('event', 'page_view', {
    page_path: currentPath,
    page_title: document.title || 'Nexvia'
  });

  router.subscribe((state) => {
    // Only track when the path actually changes (ignores hash or search param changes)
    if (state.location.pathname !== currentPath) {
      currentPath = state.location.pathname;
      gtag('event', 'page_view', {
        page_path: currentPath,
        page_title: document.title || 'Nexvia'
      });
    }
  });
}

export default router;
